module.exports = __webpack_public_path__ + "img/file-text.b58f8618.svg";